import { render, staticRenderFns } from "./EditPointPrice.vue?vue&type=template&id=4173cf51&scoped=true"
import script from "./EditPointPrice.vue?vue&type=script&lang=js"
export * from "./EditPointPrice.vue?vue&type=script&lang=js"
import style0 from "./EditPointPrice.vue?vue&type=style&index=0&id=4173cf51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173cf51",
  null
  
)

export default component.exports